import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getPositionsData } from 'models/positions'; // Importing function to get positions data

/**
 * PositionsView class extending JetView to create a chart view.
 */
export default class PositionsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Clients by occupation'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart view
                    type: 'donut', // Donut chart type
                    localId: 'chart', // Local ID for referencing the chart
                    value: '#number#', // Data field for chart values
                    lineColor: (obj) => obj.color, // Function to determine line color
                    color: '#color#', // Data field for segment colors
                    innerRadius: 60, // Inner radius for the donut chart
                    padding: { top: 10, bottom: 20, left: 20 }, // Padding around the chart
                    legend: {
                        width: 170, // Width of the legend
                        align: 'right', // Legend alignment
                        valign: 'middle', // Vertical alignment of the legend
                        marker: {
                            type: 'round', // Marker type for legend
                            width: 7, // Marker width
                            height: 8, // Marker height
                        },
                        template: (obj) => _(obj.position), // Template for legend items with localization
                    },
                    shadow: false, // Disable shadow for the chart
                    tooltip: {
                        template: (obj) => `${_('Clients')}: ${obj.number}`, // Tooltip template with localized text
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and parses data into the chart.
     */
    init() {
        this.$$('chart').parse(getPositionsData()); // Parsing positions data into the chart
    }
}

// FILE DOCUMENTED
